import { render, staticRenderFns } from "./ProductTypeForm.vue?vue&type=template&id=279b2c16&scoped=true&"
import script from "./ProductTypeForm.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeForm.vue?vue&type=style&index=0&id=279b2c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b2c16",
  null
  
)

export default component.exports